document.addEventListener("DOMContentLoaded", function () {
    var tabButtons = document.querySelectorAll('.js-product-tabs__btn');
    var tabBoxes = document.querySelectorAll('.js-product-tabs__boxes');
    var productTabsWrap = document.querySelector('.product-tabs__wrap');

    if (tabButtons.length > 0 && tabBoxes.length > 0) {
        tabButtons[0].classList.add('is-active');
        tabBoxes[0].classList.add('is-active');
    }

    tabButtons.forEach(function (button, index) {
        button.addEventListener('click', function () {

            tabButtons.forEach(function (btn) {
                btn.classList.remove('is-active');
            });
            tabBoxes.forEach(function (box) {
                box.classList.remove('is-active');
            });

            button.classList.add('is-active');
            tabBoxes[index].classList.add('is-active');

            if (window.innerWidth < 768) {
                productTabsWrap.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", function() {
    const desc = document.querySelector('.single-product__desc');
    const button = document.getElementById('read-more-less-btn');
    const lineHeight = parseFloat(getComputedStyle(desc).lineHeight);
    const maxHeight = lineHeight * 2;

    // Check if the description overflows
    if (desc.scrollHeight > maxHeight) {
        button.style.display = "block";
    }

    button.addEventListener('click', function() {
        if (desc.classList.contains('expanded')) {
            desc.classList.remove('expanded');
            desc.style.maxHeight = maxHeight + "px";
            button.textContent = "Read More";
        } else {
            desc.classList.add('expanded');
            desc.style.maxHeight = desc.scrollHeight + "px";
            button.textContent = "Read Less";
        }
    });
});
